import i18n from 'i18next'

export const UPPERCASE = 'uppercase'
export const LOWERCASE = 'lowercase'

export type TranslationFormat = typeof UPPERCASE | typeof LOWERCASE

export const t = (key: any, format?: TranslationFormat, options?: any): string => {
  const translation = i18n.t(key, options)

  // Check if the translation is a string
  if (typeof translation === 'string') {
    switch (format) {
      case UPPERCASE:
        return translation.toUpperCase()
      case LOWERCASE:
        return translation.toLowerCase()
      default:
        return translation.charAt(0).toUpperCase() + translation.slice(1)
    }
  }

  // If it's not a string, convert to string
  const stringTranslation = String(translation)
  switch (format) {
    case UPPERCASE:
      return stringTranslation.toUpperCase()
    case LOWERCASE:
      return stringTranslation.toLowerCase()
    default:
      return stringTranslation.charAt(0).toUpperCase() + stringTranslation.slice(1)
  }
}
